
export const INFO_CARD_STYLES = (theme: any) => ({
      card: {
        width: '22%',
        display: 'flex',
        flexDirection: 'column',
        direction: "ltr",
        boxShadow: theme.palette.mode === 'dark' ? '0 0 8px rgba(255, 255, 255, 1)' : '0 0 8px rgba(7, 7, 7, 0.3)',
        '@media (max-width: 768px)': {
          width: 'calc(25% - 1.5%)',
          flex: '1 0 calc(25% - 1.5%)',
        },
        borderRadius: '5px'
      },
      infocard: {
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(165, 156, 156, 1)' : 'rgba(255, 255, 255, 1)',
        border: "0.5px solid black",  
        borderRadius: '5px'
      },
      cardHeader: {
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1368' height='400' fill='none'%3E%3Cmask id='a' width='1764' height='479' x='-229' y='-6' maskUnits='userSpaceOnUse'%3E%3Cpath fill='url(%23paint0_linear)' d='M0 400h1350C1321 336 525 33 179-2c-345-34-395 236-408 402H0z'/%3E%3Cpath fill='url(%23paint1_linear)' d='M1378 177v223H0V217s219 75 327 52C436 246 717-35 965 45s254 144 413 132z'/%3E%3Cpath fill='url(%23paint2_linear)' d='M26 400l-78-16c-170 205-44-6-137-30l-4-1 4 1 137 30c37-45 89-110 159-201 399-514-45 238 1176-50 275-65 354-39 91 267H26z'/%3E%3C/mask%3E%3Cg mask='url(%23a)'%3E%3Cpath fill='white' d='M0 0h1368v400H0z'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='431' x2='397.3' y1='-599' y2='372.8' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='white'/%3E%3Cstop offset='1' stop-color='white' stop-opacity='0'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear' x1='236.5' x2='446.6' y1='-586' y2='381.5' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='white'/%3E%3Cstop offset='1' stop-color='white' stop-opacity='0'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear' x1='851.8' x2='640.4' y1='-867.2' y2='363.7' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='white'/%3E%3Cstop offset='1' stop-color='white' stop-opacity='0'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E"), linear-gradient(90deg, #005B4B, #005B4B)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: 'white',
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '0 8px',
        fontSize: '85%',
        '@media (max-width: 768px)': {
          fontSize: '60%',
          fontWeight: '200'
        },
        borderRadius: '5px 5px 0 0'
      },
      cardContent: {
        padding: '16px',
        textAlign: 'center',
        color: '#000000',
        flex: '1',
        justifyContent: 'center',
        fontSize: 'clamp(1rem, 7vw, 1.5rem)',
        display: 'flex',
        alignItems: 'center',
        '@media (max-width: 768px)': {
          fontWeight: '300',
        } 
      },
      cardsCollection: {
          display: 'flex',
          backgroundColor: 'rgba(255, 255, 255, 1)',
          padding: '1%',
          gap: '2%',
          textAlign: 'center',
          marginBottom: '20px', 
 
      }
});

